import { render } from "./DataDefinitions.vue?vue&type=template&id=73ad273c"
import script from "./DataDefinitions.vue?vue&type=script&lang=js"
export * from "./DataDefinitions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__